import { render, staticRenderFns } from "./RatingViewItem.vue?vue&type=template&id=165ee9eb&"
import script from "./RatingViewItem.vue?vue&type=script&lang=js&"
export * from "./RatingViewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports